import { adminRoutes } from 'app/constants/routes';
import { RouteBuilderItem } from 'app/routes/routeBuilder';

import { ServerSettings } from './ServerSettingsRouteComponents';

export const serverSettingsRoutes: RouteBuilderItem[] = [
  /* eslint-disable @typescript-eslint/naming-convention */
  {
    Component: ServerSettings,
    path: adminRoutes.serverSettings,
  },
  /* eslint-enable @typescript-eslint/naming-convention */
];
